import { createTheme } from '@mui/material/styles';

export const getTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: {
      main: '#D4AF37', // Premium Gold
      light: '#F5D76E',
      dark: '#B8860B',
      contrastText: mode === 'dark' ? '#0D0D0D' : '#FFFFFF',
    },
    secondary: {
      main: mode === 'dark' ? '#FFFFFF' : '#0D0D0D',
      contrastText: mode === 'dark' ? '#0D0D0D' : '#FFFFFF',
    },
    background: {
      default: mode === 'dark' ? '#0D0D0D' : '#F5F7FA',
      paper: mode === 'dark' ? '#1A1A1A' : '#FFFFFF',
    },
    text: {
      primary: mode === 'dark' ? '#FFFFFF' : '#0D0D0D',
      secondary: mode === 'dark' ? '#B3B3B3' : '#666666',
    },
    divider: 'rgba(212, 175, 55, 0.2)',
  },
  typography: {
    fontFamily: "'Outfit', sans-serif",
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.01em' },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          padding: '10px 28px',
          fontSize: '1rem',
          transition: 'all 0.3s ease',
        },
        containedPrimary: {
          background: 'linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%)',
          color: '#0D0D0D',
          boxShadow: '0 4px 15px rgba(212, 175, 55, 0.3)',
          '&:hover': {
            background: 'linear-gradient(45deg, #F5D76E 30%, #D4AF37 90%)',
            boxShadow: '0 6px 20px rgba(212, 175, 55, 0.5)',
            transform: 'translateY(-2px)',
          },
        },
        outlinedPrimary: {
          borderColor: '#D4AF37',
          color: '#D4AF37',
          '&:hover': {
            borderColor: '#B8860B',
            backgroundColor: 'rgba(212, 175, 55, 0.05)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          backgroundImage: 'none',
          border: mode === 'dark' ? '1px solid rgba(212, 175, 55, 0.1)' : '1px solid rgba(0, 0, 0, 0.05)',
          boxShadow: mode === 'dark' ? '0 10px 30px rgba(0,0,0,0.5)' : '0 10px 30px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          '&:hover': {
            borderColor: '#D4AF37',
            transform: 'translateY(-5px)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '&:hover fieldset': {
              borderColor: '#D4AF37',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#D4AF37',
            },
          },
        },
      },
    },
  },
});



